import template from './lastDayAlert.html';
import controller from './lastDayAlert.controller';
import './lastDayAlert.scss';

let lastDayAlertComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller,
};

export default lastDayAlertComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/lastDayAlert/lastDayAlert.component.js